"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFeedbackNotificationSlots = exports.default = exports.FeedbackNotification = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _useAutoclose = _interopRequireDefault(require("../useAutoclose"));
var _utils = require("../utils");
var _feedbackNotificationClasses = require("./feedbackNotificationClasses");
var _jsxRuntime = require("react/jsx-runtime");
var getFeedbackNotificationSlots = function(ownerState) {
    var color = ownerState.color;
    return {
        root: [
            'root',
            "color".concat((0, _utils.capitalize)(color))
        ],
        notification: [
            'notification'
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ]
    };
};
exports.getFeedbackNotificationSlots = getFeedbackNotificationSlots;
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = getFeedbackNotificationSlots(ownerState);
    var composedClasses = (0, _base.unstable_composeClasses)(slots, _feedbackNotificationClasses.getFeedbackNotificationUtilityClass, classes);
    return _object_spread({}, classes, composedClasses);
};
var FeedbackNotificationRoot = (0, _material.styled)('div', {
    name: 'MuiOriFeedbackNotification',
    slot: 'Root',
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.root,
            styles["color".concat((0, _utils.capitalize)(ownerState.color))]
        ];
    },
    shouldForwardProp: function(prop) {
        return (0, _utils.rootShouldForwardProp)(prop);
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread({
        position: 'fixed',
        zIndex: theme.zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 0
    }, ownerState.keepMounted && !ownerState.open && {
        visibility: 'hidden'
    });
});
var FeedbackNotificationBackdrop = (0, _material.styled)(_material.Backdrop, {
    name: 'MuiOriFeedbackNotification',
    slot: 'Backdrop',
    overridesResolver: function(_, styles) {
        return [
            styles.backdrop
        ];
    }
})({
    zIndex: -1
});
var Notification = (0, _material.styled)('div', {
    name: 'MuiOriFeedbackNotification',
    slot: 'Notification',
    skipSx: true,
    overridesResolver: function(_, styles) {
        return [
            styles.notification
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread(_define_property({
        display: 'flex',
        backdropFilter: 'blur(2px)',
        outline: 0,
        flexDirection: 'row',
        justifyItems: 'center',
        alignItems: 'flex-start',
        columnGap: theme.spacing(2),
        padding: theme.spacing(3),
        minHeight: 'unset',
        borderRadius: theme.shape.largeComponentRadius
    }, theme.breakpoints.up('md'), {
        padding: theme.spacing(6)
    }), ownerState.color === 'error' && {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText
    }, ownerState.color === 'success' && {
        backgroundColor: theme.palette.success.light,
        color: theme.palette.text.primary
    }, ownerState.color === 'warning' && {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.warning.contrastText
    }, ownerState.color === 'initial' && {
        backgroundColor: theme.palette.default.main,
        color: theme.palette.default.contrastText
    });
});
var Message = (0, _material.styled)('div', {
    name: 'MuiOriFeedbackNotification',
    slot: 'Message',
    skipSx: true,
    overridesResolver: function(_, styles) {
        return [
            styles.message
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _define_property({
        fontSize: theme.typography.body1.fontSize,
        fontWeight: 'bold',
        alignSelf: 'center',
        order: 2,
        display: 'flex',
        alignItems: 'flex-start',
        maxWidth: 250,
        '&>p': {
            fontSize: 'inherit',
            fontWeight: 'inherit'
        }
    }, theme.breakpoints.up('md'), {
        maxWidth: 350
    });
});
var IconRoot = (0, _material.styled)('div', {
    name: 'MuiOriFeedbackNotification',
    slot: 'Icon',
    skipSx: true,
    overridesResolver: function(_, styles) {
        return [
            styles.icon
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return {
        fontSize: '3rem',
        lineHeight: 1,
        '&>svg': {
            fontSize: 'inherit'
        }
    };
});
var FeedbackNotification = exports.FeedbackNotification = /*#__PURE__*/ (0, _react.forwardRef)(function(inProps, ref) {
    var props = (0, _material.useThemeProps)({
        props: inProps,
        name: 'MuiOriFeedbackNotification'
    });
    var ariaDescribedby = props.ariaDescribedby, ariaLabelledby = props.ariaLabelledby, _props_ariaModal = props.ariaModal, ariaModal = _props_ariaModal === void 0 ? true : _props_ariaModal, children = props.children, className = props.className, _props_closeAfterTransition = props.closeAfterTransition, closeAfterTransition = _props_closeAfterTransition === void 0 ? true : _props_closeAfterTransition, _props_color = props.color, color = _props_color === void 0 ? 'initial' : _props_color, _props_disableAutoFocus = props.disableAutoFocus, disableAutoFocus = _props_disableAutoFocus === void 0 ? false : _props_disableAutoFocus, _props_disableEnforceFocus = props.disableEnforceFocus, disableEnforceFocus = _props_disableEnforceFocus === void 0 ? false : _props_disableEnforceFocus, _props_disableEscapeKeyDown = props.disableEscapeKeyDown, disableEscapeKeyDown = _props_disableEscapeKeyDown === void 0 ? false : _props_disableEscapeKeyDown, _props_disablePortal = props.disablePortal, disablePortal = _props_disablePortal === void 0 ? true : _props_disablePortal, _props_disableRestoreFocus = props.disableRestoreFocus, disableRestoreFocus = _props_disableRestoreFocus === void 0 ? false : _props_disableRestoreFocus, _props_disableScrollLock = props.disableScrollLock, disableScrollLock = _props_disableScrollLock === void 0 ? true : _props_disableScrollLock, _props_hideBackdrop = props.hideBackdrop, hideBackdrop = _props_hideBackdrop === void 0 ? true : _props_hideBackdrop, _props_keepMounted = props.keepMounted, keepMounted = _props_keepMounted === void 0 ? false : _props_keepMounted, icon = props.icon, open = props.open, onClose = props.onClose, _props_timeoutMs = props.timeoutMs, timeoutMs = _props_timeoutMs === void 0 ? 2000 : _props_timeoutMs, other = _object_without_properties(props, [
        "ariaDescribedby",
        "ariaLabelledby",
        "ariaModal",
        "children",
        "className",
        "closeAfterTransition",
        "color",
        "disableAutoFocus",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "icon",
        "open",
        "onClose",
        "timeoutMs"
    ]);
    var commonProps = {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    var ownerState = (0, _react.useMemo)(function() {
        return _object_spread_props(_object_spread({}, props), {
            color: color
        });
    }, [
        color,
        props
    ]);
    var classes = useUtilityClasses(ownerState);
    var handleClose = (0, _react.useCallback)(function() {
        onClose === null || onClose === void 0 ? void 0 : onClose({}, 'backdropClick');
    }, [
        onClose
    ]);
    (0, _useAutoclose.default)({
        onClose: handleClose,
        open: open,
        timeoutMs: timeoutMs,
        autoClose: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_base.Modal, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
        slots: {
            root: FeedbackNotificationRoot,
            backdrop: FeedbackNotificationBackdrop
        },
        slotProps: {
            root: function() {
                return {
                    ownerState: ownerState
                };
            }
        },
        open: open,
        className: (0, _clsx.default)(classes.root, className)
    }, other), {
        ref: ref
    }), commonProps), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Notification, {
            className: classes.notification,
            ownerState: ownerState,
            "aria-describedby": ariaDescribedby,
            "aria-labelledby": ariaLabelledby,
            "aria-modal": ariaModal,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconRoot, {
                    ownerState: ownerState,
                    className: classes.icon,
                    children: icon
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Message, {
                    ownerState: ownerState,
                    className: classes.message,
                    children: children
                })
            ]
        })
    }));
});
var _default = exports.default = FeedbackNotification; //# sourceMappingURL=FeedbackNotification.js.map
